import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<td>{{this.guestNames}}</td>\n",{ moduleName: "uplisting-frontend/components/ui/calendar/table-cell/index.hbs" })